import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { portalUrl } from '../configuration';

import usePortalJwt from './usePortalJwt';

export default function useAccountManager(): UseQueryResult<string> {
  const { data: portalJwt, isStale } = usePortalJwt();
  return useQuery({
    enabled: Boolean(portalJwt) && !isStale,
    queryKey: ['accountManager', portalJwt],
    staleTime: Infinity,
    queryFn: async () => {
      const res = await fetch(
        `${portalUrl}/portal/api/account-manager-details`,
        {
          headers: {
            Authorization: `Bearer ${portalJwt}`,
          },
        },
      );
      const data = await res.json();
      return data.account_info.email as string;
    },
  });
}
